import { IframePages } from "../models/new-iframe.ts";

export const pagesSort: IframePages[] = [
	IframePages.TEXT_TO_IMAGE,
	IframePages.IMAGE_TO_IMAGE,
	IframePages.TEXT_TO_VECTOR,
	IframePages.CAMPAIGN,
	IframePages.ADS_EDITOR,
	IframePages.TG_TRAINING,
	IframePages.AUTOMOTIVE,
	IframePages.FIBO_LABS,
	IframePages.FIBO_EDIT,
];
